<div class="flex justify-center flex-col w-full h-full items-center">
  <div
    on:click="{playStories}"
    class="text-white icon-group cursor-pointer filter drop-shadow">
    <Play class="fill-current" />
  </div>
  <div class="absolute inset-x-0 bottom-0 h-1/3 gradient">
    <div
      class="flex justify-center items-end font-bold text-white title h-full px-2 pb-4 text-center">
      {title}
    </div>
  </div>
</div>

<script>
  import Play from '~/assets/play.svg'
  import { playerOpen } from '~/store/index.js'

  export let title

  function playStories() {
    playerOpen.set(true)
  }
</script>

<style>
  .title {
    font-size: 4vh;
  }
  .icon-group {
    height: 128px;
    width: 128px;
  }
  .gradient {
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75),
      rgba(0, 0, 0, 0)
    );
  }
</style>
